export const STACK_PACKS_FETCH = "@e-stack-packs/STACK_PACKS_FETCH";
export const STACK_PACKS_SET = "@e-stack-packs/STACK_PACKS_SET";
export const STACK_PACKS_SET_ERROR = "@e-stack-packs/STACK_PACKS_SET_ERROR";

export const STACK_PACKS_UPGRADE_START = "@e-stack-packs/UPGRADE_START";
export const STACK_PACKS_UPGRADE_SUCCESS = "@e-stack-packs/UPGRADE_SUCCESS";
export const STACK_PACKS_UPGRADE_ERROR = "@e-stack-packs/UPGRADE_ERROR";

export const STACK_PACKS_CONFIRM_MANUAL_ACTIONS_START = "@e-stack-packs/CONFIRM_MANUAL_ACTIONS_START";
export const STACK_PACKS_CONFIRM_MANUAL_ACTIONS_SUCCESS = "@e-stack-packs/CONFIRM_MANUAL_ACTIONS_SUCCESS";
export const STACK_PACKS_CONFIRM_MANUAL_ACTIONS_ERROR = "@e-stack-packs/CONFIRM_MANUAL_ACTIONS_ERROR";
